import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useLocation } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';

const Seo = ({ title, description, image, article }) => {
  const { pathname } = useLocation();
  const { site } = useStaticQuery(query);

  const {
    defaultTitle,
    titleTemplate,
    defaultDescription,
    siteUrl,
    defaultImage,
    twitterUsername,
  } = site.siteMetadata;

  const seoParams = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image || defaultImage}`,
    url: `${siteUrl}${pathname}`,
  };

  // prettier-ignore
  return (
    <Helmet title={seoParams.title} titleTemplate={titleTemplate}>
      <meta name="description" content={seoParams.description} />
      <meta name="image" content={seoParams.image} />
      {seoParams.url && <meta property="og:url" content={seoParams.url} />}
      {(article ? true : null) && <meta property="og:type" content="article" />}
      {seoParams.title && <meta property="og:title" content={seoParams.title} />}
      {seoParams.description && (<meta property="og:description" content={seoParams.description} />)}
      {seoParams.image && <meta property="og:image" content={seoParams.image} />}
      <meta name="twitter:card" content="summary_large_image" />
      {twitterUsername && (<meta name="twitter:creator" content={twitterUsername} />)}
      {seoParams.title && <meta name="twitter:title" content={seoParams.title} />}
      {seoParams.description && (<meta name="twitter:description" content={seoParams.description} />)}
      {seoParams.image && <meta name="twitter:image" content={seoParams.image} />}
    </Helmet>
  )
};

export default Seo;

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  article: PropTypes.bool,
};

Seo.defaultProps = {
  title: null,
  description: null,
  image: null,
  article: false,
};

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
      }
    }
  }
`;
